import service from '@/store/services/header-services'

const state = {
    list: {},
    item: {},
    meta: {},
    cate: [],
    newes: [],
    discount: [],
    website: {},
    getnav: [],
    getfooter: {},
    navcontent: {},
    getfront: {},
    getfb: {},
    gethostSearch: {},
    isNavFetched: false,
    ga_id: '',
    ads: {
        id: '',
        buy: ''
    },
    ga_state: true,
    seo: {},
    mc:'',
    facebook:'',
    // 審查
    // 隱私權條款、消費者權益、會員服務條款。
    privacy_Policy:{},
    consumer_Rights:{},
    terms_Service:{},
    //文章
    article: [],
    isarticle: false,
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, item) => {
        state.item = item;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_CATE: (state, cate) => {
        state.cate = cate;
    },
    SET_NEWES: (state, newes) => {
        state.newes = newes;
    },
    SET_DISCOUNT: (state, discount) => {
        state.discount = discount;
    },
    SET_WEBSITE: (state, website) => {
        state.website = website;
    },
    SET_GETNAV: (state, getnav) => {
        state.getnav = getnav;
    },
    SET_GETFOOTER: (state, getfooter) => {
        state.getfooter = getfooter;
    },
    SET_NAVCONTENT: (state, navcontent) => {
        state.navcontent = navcontent;
    },
    SET_GETFRONT: (state, getfront) => {
        state.getfront = getfront;
    },
    SET_GETFB: (state, getfb) => {
        state.getfb = getfb;
    },
    SET_GETHOSTSEARCH: (state, gethostSearch) => {
        state.gethostSearch = gethostSearch;
    },
    SET_ISNAVFERCHED: (state, isNavFetched) => {
        state.isNavFetched = isNavFetched;
    },
    SET_GA_ID: (state, ga_id) => {
        state.ga_id = ga_id;
    },
    SET_GA_STATE: (state, ga_state) => {
        state.ga_state = ga_state;
    },
    SET_SEO: (state, seo) => {
        state.seo = seo;
    },
    SET_ADS: (state, ads) => {
        state.ads = ads;
    },
    SET_MC: (state, mc) => {
        state.mc = mc;
    },
    SET_FACEBOOK: (state, facebook) => {
        state.facebook = facebook;
    },
    SET_PRIVACY_POLICY: (state, privacy_Policy) => {
        state.privacy_Policy = privacy_Policy;
    },
    SET_CONSUMER_RIGHTS: (state, consumer_Rights) => {
        state.consumer_Rights = consumer_Rights;
    },
    SET_MEMBER_SERVICE: (state, terms_Service) => {
        state.terms_Service = terms_Service;
    },
    SET_ARTICLE: (state, article) => {
        state.article = article;
    },
    SET_ISARTICLE: (state, isarticle) => {
        state.isarticle = isarticle;
    },

};

const actions = {
    list({
        commit
    }, params) {
        commit('SET_CATE', params.CATE);
        commit('SET_NEWES', params.NEW);
        commit('SET_DISCOUNT', params.DISCOUNT);
    },
    // 获取oic
    get({
        commit
    }) {
        // console.log('请求oic');

        return service.getcartList().then((response) => {
            if (response.result) {
                if (response.data && response.data.CATE !== undefined) {
                    commit('SET_CATE', response.data.CATE);
                }
                if (response.data && response.data.NEW !== undefined) {
                    commit('SET_NEWES', response.data.NEW);
                }
                // commit('SET_CATE', response.data.CATE);
                // commit('SET_NEWES', response.data.NEW);
                // commit('SET_DISCOUNT', response.data ? .DISCOUNT);
                if (response.data && response.data.DISCOUNT !== undefined) {
                    commit('SET_DISCOUNT', response.data.DISCOUNT);
                }
            }
            // console.log(response);
            // console.log(params);
        });

    },
    // 获取图标fb 和 line等
    getwebsite({
        commit
    }, url) {
        return service.getwebsite(url).then((response) => {

            if (response.result) {
                commit('SET_WEBSITE', response.data)
            }
            // console.log(response);
            return response.data;

        })
    },
    getnav({
        commit
    }, clientUrl) {
        return service.getnav(clientUrl).then((response) => {
            let seo = {
                meta_description: '',
                og_title: '',
                og_url: '',
                meta_keywords: '',
                og_image: '',
                og_description: '',
            }
            for (const key in response) {
                switch (response[key].type) {
                    case 'header':
                        commit('SET_GETNAV', response[key].data)
                        break;
                    case 'footer':
                        commit('SET_GETFOOTER', response[key].data);
                        const data = response[key].data;
                        const namesToCheck = ['隱私權條款', '消費者權益', '會員服務條款'];
                        const filteredItems = data.filter(item => namesToCheck.includes(item.name));
                        filteredItems.forEach(item => {
                            switch (item.name) {
                              case '隱私權條款':
                                commit('SET_PRIVACY_POLICY', item);
                                break;
                              case '消費者權益':
                                commit('SET_CONSUMER_RIGHTS', item);
                                break;
                              case '會員服務條款':
                                commit('SET_MEMBER_SERVICE', item);
                                break;
                              default:
                                // 如果有默认行为，可以在这里处理
                                break;
                            }
                          });
                        break;
                    case 'front':
                        commit('SET_GETFRONT', response[key].data)
                        break;
                    case 'hostSearch':
                        commit('SET_GETHOSTSEARCH', response[key].data)
                        break;
                    case 'ga_id':
                        commit('SET_GA_ID', response[key].data)
                        break;
                    case 'seo':
                        commit('SET_SEO', response[key].data)
                        seo = response[key].data;
                        break;
                    case 'ads':
                        commit('SET_ADS', response[key].data)
                        break;
                    case 'mc':
                        commit('SET_MC', response[key].data)
                        break;
                    case 'facebook':
                        commit('SET_FACEBOOK', response[key].data)
                        break;
                    case 'article':
                        commit('SET_ARTICLE', response[key].data)
                        break;
                        case 'isarticle':
                        commit('SET_ISARTICLE', response[key].data)
                    default:
                        break;
                }
                // if (response[key].type=='header') {
                //     // console.log('header');
                //     commit('SET_GETNAV', response[key].data)
                // }
                // if (response[key].type=='footer') {
                //     // console.log('footer');
                //     commit('SET_GETFOOTER', response[key].data)
                // }
                // if (response[key].type=='front') {
                //     // console.log('front');
                //     commit('SET_GETFRONT', response[key].data)
                // }
                // if (response[key].type=='hostSearch') {
                //     commit('SET_GETHOSTSEARCH', response[key].data)

                // }
                // if (response[key].type=='ga_id') {
                //     commit('SET_GA_ID', response[key].data)
                // }
            }

            return seo;

        })
    },
    //获取fb内容
    getfb({
        commit
    }) {
        return service.getfb().then((response) => {
            commit('SET_GETFB', response.data)
            // console.log(response.data);
        })
    }
}


const getters = {
    list: state => state.list,
    item: state => state.item,
    cate: state => state.cate,
    newes: state => state.newes,
    discount: state => state.discount,
    getnav: state => state.getnav,
    navcontent: state => state.navcontent,
    getfb: state => state.getfb,
    website: state => state.website.company_info,
    getfooter: state => state.getfooter,
    getfront: state => state.getfront,
    ga_id: state => state.ga_id,
    ga_state: state => state.ga_state,
    seo: state => state.seo,
    ads_id: state => state.ads_id,
    mc: state => state.mc,
    facebook: state => state.facebook,
    privacy_Policy: state => state.privacy_Policy,
    consumer_Rights: state => state.consumer_Rights,
    terms_Service: state => state.terms_Service,
    article: state => state.article,
    isarticle: state => state.isarticle,
};

const header = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default header;